<div class="two-option-modal" [ngClass]="{'light-theme': !option.darkTheme,'dark-theme': option.darkTheme}">
    <div class="close-modal" (click)="activeModal.close('')">
        <img appImageSelector alt="mt-image" imageType="icon" [imageKey]="option.darkTheme ? 'close' : 'close-gray'">
    </div>

    <div class="title">
        {{option.title | lang }}
    </div>

    <div class="img">
        <img appImageSelector alt="mt-image" [imageType]="option.imageType" [imageKey]="option.imageKey" width="70">
    </div>

    <div class="message" *ngIf="option?.message">
        <span>{{option.message | lang: option.messageParam ? option.messageParam : ''}}</span> <br>
        <span *ngIf="option.emailLogin">
            <img class="img-contact" appImageSelector imageType="icon" imageKey="mail-contacto">{{ option.emailLogin }} </span>
    </div>

    <div class="zone-detail my-3" *ngIf="!!option?.zoneDetail">
      <div class="my-2 error" *ngIf="option?.zoneDetail?.topError">
        <span>{{ option?.zoneDetail?.topError | lang }}</span>
      </div>
      <strong>{{ option?.zoneDetail?.zoneName }}</strong><br>
      {{'ubication' | lang }}: <strong>{{ option?.zoneDetail?.parentZone }}</strong><br>
      <span class="capitalize">{{'tag' | lang | lowercase }}</span>: <strong>{{ option?.zoneDetail?.tag }}</strong><br>
      <div class="my-2 error">
        <span innerHTML="{{ option?.zoneDetail?.bottomError | lang: option?.zoneDetail?.bottomErrorParam }}"
              *ngIf="option?.zoneDetail?.bottomError"></span>
      </div>
    </div>

    <div class="detail my-2" *ngIf="!!option?.detail">
      <strong>{{ option?.detail?.titleName }}</strong><br>
      <strong>{{ option?.detail?.subtitle }}</strong><br>
    </div>

    <div class="button-group flex-row" *ngIf="!option?.singleButton">
        <app-button *ngIf="option?.cancelButtonText" class="cancel shadowed rounded" [text]="option.cancelButtonText" (clickHandler)="activeModal.close('')"></app-button>

        <app-button-state *ngIf="option?.actionButtonText" class="action rounded shadowed ml-60" [text]="option.actionButtonText"
            (clickHandler)="activeModal.close(true)"></app-button-state>
    </div>

    <div class="d-flex justify-content-center py-3" *ngIf="option?.singleButton">
      <app-button-state class="action rounded shadowed" [text]="option.actionButtonText"
        (clickHandler)="activeModal.close(true)"></app-button-state>
    </div>
</div>
